module.exports = __webpack_public_path__ + "static/media/July2021Newsletter.f0b65ee2.pdf";